module.exports = __webpack_public_path__ + "static/media/Emojione_1F4DB.4f63d59f.svg";